(() => {
  const HIDDEN_CLASS = 'is-hidden-by-scroll';
  const TOP_THRESHOLD = 60;

  const updateVisibility = () => {
    const offers = document.querySelectorAll(
      '[data-digi-floating-offer]'
    );

    const isPastTop = window.scrollY > TOP_THRESHOLD;

    offers.forEach((offer) => {
      const action =
        offer.dataset.digiFloatingAction || 'anchor';

      const hideOnScroll =
        offer.dataset.digiHideOnScroll === 'true';

      const shouldHide =
        action === 'anchor' &&
        hideOnScroll &&
        isPastTop;

      offer.classList.toggle(
        HIDDEN_CLASS,
        shouldHide
      );
    });
  };

  const scrollToTarget = (href) => {
    if (
      !href ||
      !href.startsWith('#') ||
      href === '#'
    ) {
      return false;
    }

    let target;

    try {
      target = document.querySelector(href);
    } catch (error) {
      return false;
    }

    if (!target) return false;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    if (
      window.history &&
      window.history.replaceState
    ) {
      window.history.replaceState(
        null,
        '',
        href
      );
    }

    return true;
  };

  const openPopup = (link) => {
    const popupId = link.getAttribute('aria-controls');
    const popup = popupId
      ? document.getElementById(popupId)
      : null;

    if (!popup || typeof popup.showModal !== 'function') {
      return false;
    }

    popup.showModal();
    document.body.classList.add('digi-floating-popup-open');

    return true;
  };

  const closePopup = (popup) => {
    if (!popup) return;

    if (popup.open) {
      popup.close();
    }

    document.body.classList.remove('digi-floating-popup-open');
  };

  const bindFloatingOffer = (scope = document) => {
    const links = scope.querySelectorAll(
      '[data-digi-floating-offer-link]'
    );

    links.forEach((link) => {
      if (
        link.dataset.digiFloatingOfferBound === 'true'
      ) {
        return;
      }

      link.dataset.digiFloatingOfferBound = 'true';

      link.addEventListener('click', (event) => {
        const action =
          link.dataset.digiFloatingAction || 'anchor';

        event.preventDefault();

        const offer = link.closest(
          '[data-digi-floating-offer]'
        );

        if (action === 'popup') {
          openPopup(link);
          offer?.classList.remove(HIDDEN_CLASS);
          return;
        }

        const href = link.getAttribute('href');

        if (scrollToTarget(href)) {
          const hideOnScroll =
            offer?.dataset.digiHideOnScroll === 'true';

          if (hideOnScroll) {
            offer?.classList.add(HIDDEN_CLASS);
          } else {
            offer?.classList.remove(HIDDEN_CLASS);
          }
        }
      });
    });

    const popups = scope.querySelectorAll(
      '[data-digi-floating-popup]'
    );

    popups.forEach((popup) => {
      if (
        popup.dataset.digiFloatingPopupBound === 'true'
      ) {
        return;
      }

      popup.dataset.digiFloatingPopupBound = 'true';

      popup
        .querySelector('[data-digi-floating-popup-close]')
        ?.addEventListener('click', () => {
          closePopup(popup);
        });

      popup
        .querySelector('[data-digi-floating-popup-cta]')
        ?.addEventListener('click', (event) => {
          const target = event.currentTarget.dataset.digiFloatingTarget;

          closePopup(popup);

          scrollToTarget(target);

          document
            .querySelectorAll('[data-digi-floating-offer]')
            .forEach((offer) => {
              if (
                offer.dataset.digiFloatingAction === 'popup'
              ) {
                offer.classList.remove(HIDDEN_CLASS);
              }
            });
        });

      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          closePopup(popup);
        }
      });

      popup.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup(popup);
      });

      popup.addEventListener('close', () => {
        document.body.classList.remove(
          'digi-floating-popup-open'
        );
      });
    });

    updateVisibility();
  };

  let ticking = false;

  const handleScroll = () => {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(() => {
      updateVisibility();
      ticking = false;
    });
  };

  bindFloatingOffer();

  window.addEventListener(
    'scroll',
    handleScroll,
    { passive: true }
  );

  window.addEventListener(
    'pageshow',
    updateVisibility
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      bindFloatingOffer(event.target);
    }
  );
})();